module.exports = __webpack_public_path__ + "img/gray-chevron-up-20x20.2ae7a993.svg";